module.exports = "<div>\n    <ContentLoader height=\"30\" :primaryColor=\"dtPalette['grey-3']\" >\n        <rect x=\"10\" y=\"5\" :rx=\"dtTextRadius\" :ry=\"dtTextRadius\" width=\"100\" :height=\"dtTextHeight\" />\n        <rect x=\"10\" y=\"13\" :rx=\"dtTextRadius\" :ry=\"dtTextRadius\" width=\"60\" :height=\"dtTextHeight\" />\n        <rect x=\"10\" y=\"21\" :rx=\"dtTextRadius\" :ry=\"dtTextRadius\" width=\"150\" :height=\"dtTextHeight\" />\n        <circle cx=\"96%\" cy=\"13\" r=\"8\" />\n    </ContentLoader>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/containers/ticket/loaders/ticket-chat-header-loader/template.html
// module id = FFcy
// module chunks = 0